import { StandardEvents } from '@shopify/events';

const pending = new WeakMap();
const isPackageSection = (section) => section?.dataset.bmPackageAdd === 'true';

const openCart = () => {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.querySelector('cart-drawer-component')?.setAttribute('auto-open', '');
  if (typeof drawer.open === 'function') drawer.open();
  else customElements.whenDefined('theme-drawer').then(() => drawer.open());
};

const syncOffer = (section, offer) => {
  if (!section || !offer) return;
  const variant = section.querySelector('[name="id"]');
  const quantity = section.querySelector('[data-bm-quantity]');
  const submit = section.querySelector('.bm-sales-buy__submit');
  if (variant && offer.dataset.variantId) {
    variant.value = offer.dataset.variantId;
    variant.disabled = offer.dataset.variantAvailable === 'false';
  }
  if (quantity) quantity.value = isPackageSection(section) ? '1' : offer.dataset.quantity || '1';
  if (submit) submit.disabled = offer.dataset.variantAvailable === 'false';
  return submit;
};

const release = (section, transaction) => {
  if (pending.get(section) !== transaction) return;
  const drawerComponent = document.querySelector('#cart-drawer cart-drawer-component');
  if (transaction.autoOpen) drawerComponent?.setAttribute('auto-open', '');
  pending.delete(section);
  section.removeAttribute('aria-busy');
  section.querySelector('form')?.removeAttribute('aria-busy');
};

 document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const section = event.target.closest?.('.bm-sales-buy');
  const transaction = section && pending.get(section);
  if (!transaction || !event.promise) return;
  event.promise.then(({ detail }) => {
    if (detail?.didError) release(section, transaction);
  }, () => release(section, transaction));
});

document.addEventListener('bm:cart-ready', (event) => {
  const section = event.detail?.section;
  const transaction = section && pending.get(section);
  if (!transaction) return;
  if (!event.detail?.didError) openCart();
  release(section, transaction);
});

 document.addEventListener('submit', (event) => {
  const form = event.target;
  const section = form.closest?.('.bm-sales-buy');
  if (!isPackageSection(section)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pending.has(section)) return;
  const offer = section.querySelector('[data-bm-offer].is-selected');
  const submit = syncOffer(section, offer);
  if (!submit || submit.disabled) return;
  const transaction = {};
  pending.set(section, transaction);
  section.setAttribute('aria-busy', 'true');
  form.setAttribute('aria-busy', 'true');
  const drawerComponent = document.querySelector('#cart-drawer cart-drawer-component');
  transaction.autoOpen = drawerComponent?.hasAttribute('auto-open') || false;
  drawerComponent?.removeAttribute('auto-open');
  const component = form.closest('product-form-component');
  const add = () => {
    try {
      if (!component || !component.isConnected) {
        release(section, transaction);
        return;
      }
      component.handleSubmit(event);
    } catch (error) {
      release(section, transaction);
      const status = section.querySelector('[ref="liveRegion"]');
      if (status) status.textContent = 'No se pudo agregar el paquete. Inténtalo de nuevo.';
    }
  };
  if (typeof component?.handleSubmit === 'function') add();
  else customElements.whenDefined('product-form-component').then(add);
}, true);

 document.addEventListener('click', (event) => {
  const offer = event.target.closest?.('[data-bm-offer]');
  if (!offer) return;
  const section = offer.closest('.bm-sales-buy');
  if (!section) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pending.has(section)) return;
  section.querySelectorAll('[data-bm-offer]').forEach((button) => {
    button.classList.toggle('is-selected', button === offer);
    button.setAttribute('aria-pressed', button === offer ? 'true' : 'false');
  });
  syncOffer(section, offer);
}, true);

const init = (root) => {
  root.querySelectorAll('.bm-sales-buy').forEach((section) => {
    if (!pending.has(section)) syncOffer(section, section.querySelector('[data-bm-offer].is-selected'));
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
else init(document);
document.addEventListener('shopify:section:load', (event) => init(event.target));
